import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeSession } from './utils/rateLimiter';

// Initialize session for rate limiting
initializeSession();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary fullPage message="The application ran into an unexpected error. Please refresh the page.">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
